import ArenaIcon from './icons/arena-icon';
import ArmorIcon from './icons/armor-icon';
import BeastIcon from './icons/beast-icon';
import BowIcon from './icons/bow-icon';
import CaesarIcon from './icons/caesar-icon';
import ChestIcon from './icons/chest-icon';
import ColumnsIcon from './icons/columns-icon';
import CrystalIcon from './icons/crystal-icon';
import DungeonIcon from './icons/dungeon-icon';
import GemIcon from './icons/gem-icon';
import HallIcon from './icons/hall-icon';
import LegendaryIcon from './icons/legendary-icon';
import LieutenantIcon from './icons/lieutenant-icon';
import LyreIcon from './icons/lyre-icon';
import MoonIcon from './icons/moon-icon';
import MountIcon from './icons/mount-icon';
import NikeIcon from './icons/nike-icon';
import NoteIcon from './icons/note-icon';
import PotionIcon from './icons/potion-icon';
import PuzzleIcon from './icons/puzzle-icon';
import QuestIcon from './icons/quest-icon';
import SparklessIcon from './icons/sparkless-icon';
import SpectreIcon from './icons/spectre-icon';
import SwordIcon from './icons/sword-icon';
import WingfootIcon from './icons/wingfoot-icon';

export const icons = {
  arena: {
    Icon: ArenaIcon,
    category: 'crypts',
    collectible: true,
    color: '#FF3C44',
    id: 'arena',
    label: 'Arène',
    order: '5.3',
  },
  armor: {
    Icon: ArmorIcon,
    category: 'items',
    collectible: true,
    color: '#FFAE49',
    id: 'armor',
    label: 'Coffre Épique',
    order: '3.6',
  },
  beast: {
    Icon: BeastIcon,
    category: 'quests',
    collectible: true,
    color: '#685587',
    id: 'beast',
    label: 'Animal Mythique',
    order: '4.3',
  },
  bow: {
    Icon: BowIcon,
    category: 'challenges',
    collectible: true,
    color: '#4BC6EE',
    id: 'bow',
    label: "Défi d'Ulysse",
    order: '2.2',
  },
  caesar: {
    Icon: CaesarIcon,
    category: 'locations',
    collectible: false,
    color: '#3CBC76',
    id: 'caesar',
    label: "Point d'observation",
    order: '1.2',
  },
  chest: {
    Icon: ChestIcon,
    category: 'items',
    collectible: true,
    color: '#FFAE49',
    id: 'chest',
    label: 'Coffre',
    order: '3.4',
  },
  columns: {
    Icon: ColumnsIcon,
    category: 'locations',
    collectible: false,
    color: '#7DC89E',
    id: 'columns',
    label: "Point d'intérêt",
    order: '1.3',
  },
  crystal: {
    Icon: CrystalIcon,
    category: 'items',
    collectible: true,
    color: '#CCA527',
    id: 'crystal',
    label: 'Crystal',
    order: '3.3',
  },
  dungeon: {
    Icon: DungeonIcon,
    category: 'crypts',
    collectible: true,
    color: '#FF3C44',
    id: 'dungeon',
    label: 'Crypte',
    order: '5.2',
  },
  gem: {
    Icon: GemIcon,
    category: 'items',
    collectible: true,
    color: '#CCA527',
    id: 'gem',
    label: 'Ambroisie',
    order: '3.2',
  },
  hall: {
    Icon: HallIcon,
    category: 'locations',
    collectible: false,
    color: '#2C8A56',
    id: 'hall',
    label: 'Halle des Dieux',
    order: '1.1',
  },
  legendary: {
    Icon: LegendaryIcon,
    category: 'quests',
    collectible: true,
    color: '#685587',
    id: 'legendary',
    label: 'Animal Légendaire',
    order: '4.2',
  },
  lieutenant: {
    Icon: LieutenantIcon,
    category: 'quests',
    collectible: true,
    color: '#685587',
    id: 'lieutenant',
    label: 'Lieutenant',
    order: '4.4',
  },
  lyre: {
    Icon: LyreIcon,
    category: 'challenges',
    collectible: true,
    color: '#96D9F0',
    id: 'lyre',
    label: 'Grande Lyre',
    order: '2.6',
  },
  moon: {
    Icon: MoonIcon,
    category: 'items',
    collectible: true,
    color: '#031363',
    id: 'moon',
    label: 'Coffre Nocturne',
    order: '3.1',
  },
  mount: {
    Icon: MountIcon,
    category: 'quests',
    collectible: true,
    color: '#685587',
    id: 'mount',
    label: 'Monture',
    order: '4.1',
  },
  nike: {
    Icon: NikeIcon,
    category: 'quests',
    collectible: true,
    color: '#8E72B9',
    id: 'nike',
    label: 'Fragent de Niké',
    order: '4.5',
  },
  note: {
    Icon: NoteIcon,
    category: 'challenges',
    collectible: true,
    color: '#96D9F0',
    id: 'note',
    label: 'Petite Lyre',
    order: '2.5',
  },
  potion: {
    Icon: PotionIcon,
    category: 'locations',
    collectible: false,
    color: '#7DC89E',
    id: 'potion',
    label: 'Chaudron de Circé',
    order: '1.4',
  },
  puzzle: {
    Icon: PuzzleIcon,
    category: 'challenges',
    collectible: true,
    color: '#4BC6EE',
    id: 'puzzle',
    label: 'Défi fresque',
    order: '2.3',
  },
  quest: {
    Icon: QuestIcon,
    category: 'quests',
    collectible: true,
    color: '#8E72B9',
    id: 'quest',
    label: 'Quête Cachées',
    order: '4.6',
  },
  sparkless: {
    Icon: SparklessIcon,
    category: 'challenges',
    collectible: true,
    color: '#4BC6EE',
    id: 'sparkless',
    label: 'Défi constellation',
    order: '2.4',
  },
  spectre: {
    Icon: SpectreIcon,
    category: 'crypts',
    collectible: true,
    color: '#CC3137',
    id: 'spectre',
    label: 'Antre de Spectre',
    order: '5.1',
  },
  sword: {
    Icon: SwordIcon,
    category: 'items',
    collectible: true,
    color: '#FFAE49',
    id: 'sword',
    label: 'Coffre Gardé',
    order: '3.5',
  },
  wingfoot: {
    Icon: WingfootIcon,
    category: 'challenges',
    collectible: true,
    color: '#4BC6EE',
    id: 'wingfoot',
    label: 'Défi déplacement',
    order: '2.1',
  },
};

export default { icons };
